import React, { useCallback, useEffect, useState } from 'react';

import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';

import MainScreen from './MainScreen';
import Settings from './Settings';
import SettingsProfile from './Settings/SettingsProfile';

import { IUserProfileModal, ProfileScreensEnum } from './interfaces';
import { useOpenConfirmLogoutModal } from '@components/ConfirmLogoutModal';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useChatState } from '@core/chat/context';
import { useModalCTAContext } from '@providers/ModalCTAProvider';

const UserProfileModal = ({ onClose, isOpen }: IUserProfileModal) => {
  const [activeScreen, setActiveScreen] = useState<ProfileScreensEnum>(
    ProfileScreensEnum.DEFAULT,
  );
  const { setValuesForModal } = useModalCTAContext();

  const {
    open: isOpenedConfirmLogoutModal,
    openModal: onOpenLogoutModal,
    closeModal: onCloseConfirmLogoutModal,
  } = useOpenConfirmLogoutModal();

  const eventContext = useMytaverseEvent();
  const cleanStates = eventContext?.cleanStates;
  const { resetState } = useChatState();

  useEffect(() => {
    if (!isOpen) {
      setActiveScreen(ProfileScreensEnum.DEFAULT);
    }
  }, [isOpen]);

  const render = () => {
    switch (activeScreen) {
      case ProfileScreensEnum.SETTINGS:
        return <Settings onClose={onClose} setActiveScreen={setActiveScreen} />;
      case ProfileScreensEnum.SETTINGS_LANGUAGE:
        return (
          <SettingsProfile
            onClose={onClose}
            setActiveScreen={setActiveScreen}
          />
        );
      case ProfileScreensEnum.DEFAULT:
        return (
          <MainScreen
            onClose={onClose}
            setActiveScreen={setActiveScreen}
            onOpenLogoutModal={onOpenLogoutModal}
          />
        );
    }
  };

  const handleOnConfirmLogout = useCallback(() => {
    cleanStates?.();
    resetState();
  }, [cleanStates, resetState]);

  useEffect(() => {
    setValuesForModal({
      open: isOpenedConfirmLogoutModal,
      altStyling: true,
      onClose: onCloseConfirmLogoutModal,
      onConfirm: handleOnConfirmLogout,
      isConfirmLogoutModal: true,
    });
  }, [
    isOpenedConfirmLogoutModal,
    setValuesForModal,
    onCloseConfirmLogoutModal,
    handleOnConfirmLogout,
  ]);

  return (
    <>
      <SwipeableDrawer
        position={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        onClose={onClose}
        onOpen={onClose}
        sx={{ '& .MuiDrawer-paper': { zIndex: 10002 } }}
      >
        {render()}
      </SwipeableDrawer>
    </>
  );
};

export default UserProfileModal;
